export default __webpack_public_path__ + "static/14aa-0e35210e2fbab296dd57cbc0e5ac5bc3.png";